<div class="tree-outer">
  <mat-toolbar class="mat-accent m-0 TreeToolbar">
    <mat-toolbar-row class="TreeHeader">
      <!-- <span class="title dialog-title">Tree</span> -->
      <div class="TreeHeader_options">
        <!-- input buttons -->
        <div *ngFor="let button of toolbarButtons">
          <button
            *ngIf="!search"
            mat-icon-button
            (click)="toolbarButtonClick(button.id)"
            matTooltip="{{ button.toolTip }}">
            <mat-icon>{{ button.matIcon }}</mat-icon>
          </button>
        </div>

        <!-- default buttons -->
        <button
          *ngIf="!search"
          mat-icon-button
          (click)="searchNode()"
          matTooltip="Search Node">
          <mat-icon aria-label="Search">search</mat-icon>
        </button>

        <div *ngIf="search" class="TreeHeader_search_bar">
          <button
            *ngIf="search"
            mat-icon-button
            (click)="RemoveSearchBar()"
            matTooltip="Back">
            <mat-icon>arrow_back</mat-icon>
          </button>

          <mat-form-field class="search-field">
            <mat-label>Search</mat-label>
            <input
              class="CustomsearchNode"
              matInput
              type="text"
              [(ngModel)]="searchText"
              autofocus
              autocomplete="off" />
            <button
              *ngIf="searchText"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clearSearchField()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <!-- mat menu -->
          <mat-menu #menu="matMenu">
            <label class="example-radio-button">Search by:</label>
            <mat-radio-group
              [(ngModel)]="searchWithParam"
              class="example-radio-group"
              (change)="searchNode()">
              <mat-radio-button class="example-radio-button" value="id"
                >ID</mat-radio-button
              >
              <mat-radio-button class="example-radio-button" value="name"
                >Name</mat-radio-button
              >
            </mat-radio-group>
          </mat-menu>
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            matTooltip="Search Param">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-menu #rightMenu="matMenu" style="z-index: 100">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item>{{ item.data.id }}</button>
      <!-- <button mat-menu-item (click)="clickSnapShot()">SnapShot</button> -->
    </ng-template>
  </mat-menu>

  <!-- tree -->
  <div class="ztree-outer">
    <div
      class="treeNodes_contextmenu"
      [style.left]="menuTopLeftPosition.x"
      [style.top]="menuTopLeftPosition.y"
      [matMenuTriggerFor]="rightMenu"></div>
    <div id="ztree" class="ztree showIcon"></div>
  </div>
</div>
